module.exports = __webpack_public_path__ + "img/disconnect.04e63d91.svg";